import { makeStyles } from '@material-ui/core'
import { INFO_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  tabsContainer: {
    marginBottom: 12
  },
  tabs: {
    '& .Mui-selected': {
      color: INFO_COLORS[700]
    },
    '& .MuiTabs-indicator': {
      backgroundColor: INFO_COLORS[700]
    }
  }
}))
